<template>
  <div class="flex flex-col min-h-screen w-full">
    <!-- Header -->
    <header class="bg-surface-light p-4 w-full sticky top-0 shadow-sm left-0 right-0 max-h-[76px] flex flex-row items-center justify-between z-50">
      <!-- LHS -->
      <div class="flex space-x-2 items-center justify-start flex-grow max-w-1/2 w-full">
        <slot name="header-left" />
      </div>
      <!-- RHS -->
      <div class="space-x-4 flex flex-row">
        <slot name="header-right" />
      </div>
    </header>

    <main class="flex-grow p-2 sm:p-4 md:p-8 min-h-[calc(100vh-76px)] bg-surface-light">
      <slot name="page" />
    </main>
    <div id="teleport-target" />
    <div id="modal" />
  </div>
</template>

<script setup>
</script>
